import React from "react";
import HomePage from "../containers/homePage/HomePage";
import ExecutiveOverview from "../containers/ExecutiveOverview/ExecutiveOverview";
import Program from "../containers/Program/Program";
import MonitorAlert from "../containers/MonitorAlert/MonitorAlertReal";
import IntelligentAnalysisReports from "../containers/IntelligentAnalysisReports/IntelligentAnalysisReports";
import ConfigurationSetting from "../containers/ConfigurationSetting/ConfigurationSetting";
import PermissionManagement from "../containers/PermissionManagement/PermissionManagement";
import { Notes, ProgramDetail, ProcessOptimization } from "@amzn/msa-static-website-development";
import { CommonContext } from "../types/commonContext";

export type SystemType = "MSA" | "Atlas" | "global";

export interface RouteItem {
  id: string;
  label: string;
  href: string;
  element: React.ReactNode | ((common: CommonContext) => React.ReactNode);
  showInMenu?: boolean;
  system: SystemType;
}

/**
 * Unified route and menu configuration.
 *
 * - id: matches the API feature name (snake_case) for permission checks
 * - label: sidebar menu display name
 * - href: route path
 * - element: React component to render
 * - showInMenu: whether to show in sidebar (default true)
 */
const ROUTE_CONFIG: RouteItem[] = [
  {
    id: "executive_overview",
    label: "Monitor & Alert",
    href: "/overview",
    element: <ExecutiveOverview />,
    system: "MSA",
  },
  // {
  //   id: "program",
  //   label: "Program Overview",
  //   href: "/programs",
  //   element: <Program />,
  // },
  {
    id: "monitor_alert",
    label: "Monitor & Alert(Quick)",
    href: "/monitor",
    element: <MonitorAlert />,
    system: "MSA",
  },
  {
    id: "intelligent_analysis",
    label: "Intelligent Analysis",
    href: "/analysis",
    element: <IntelligentAnalysisReports initialView="main" />,
    system: "MSA",
  },
  {
    id: "report_agent",
    label: "Report Agent",
    href: "/reports",
    element: <IntelligentAnalysisReports initialView="reports" />,
    system: "MSA",
  },
  {
    id: "process_optimization",
    label: "Process Optimization",
    href: "/optimization",
    element: <ProcessOptimization />,
    system: "MSA",
  },
  {
    id: "configuration_setting",
    label: "Configuration Setting",
    href: "/configuration",
    element: <ConfigurationSetting />,
    system: "global",
  },
  {
    id: "permission_management",
    label: "Permission Management",
    href: "/permissions",
    element: <PermissionManagement />,
    system: "global",
  },
  {
    id: "program_detail",
    label: "ProgramDetail",
    href: "/program_detail",
    element: <ProgramDetail />,
    system: "Atlas",
  },
  {
    id: "notes",
    label: "Notes",
    href: "/notes/*",
    element: (common: CommonContext) => {
      const NotesAny = Notes as any;
      return <NotesAny common={common} />;
    },
    system: "Atlas",
  },
];

export default ROUTE_CONFIG;
